export enum CustomFilterDialogModes {
  Save,
  Edit,
}
